import React, { useState } from "react";

import { SERVER_ } from  '../config';


const Calculadora = () =>{


const formatearNumeroConComas = (numero:any)=> {
  // Convierte la entrada a un número (si es una cadena)
  const numeroComoNumero = parseFloat(numero);

  // Verifica si el número es un número válido
  if (isNaN(numeroComoNumero)) {
    return 'No es un número válido';
  }

  // Formatea el número con comas y dos decimales
  return numeroComoNumero.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
}


 const [ generado, setGenerado ] = useState<any>(false)
 const [ generando, setGenerando ] = useState<any>(false)


 const [ inversion, setInversion ] = useState<any>(100000.00)
 const [ tasa_incremento, setTasaIncremento ] = useState<any>(2)
 const [ meses_inversion, setMesesInversion ] = useState<any>(12)
 const [ tipo_retiro, setTipoRetiro ] = useState<any>("finalizando")


 const [ f17, setF17 ] = useState<any>(0)


 const [ tabla_final, setTablaFinal ] = useState<any>([])

 const generarReporte = ()=>{

     setGenerando(true)

     setF17( inversion + 0 + 0 )


     let filas = Array.from({ length: meses_inversion }, (_, index) => index)

     let X : any = []
     let index = 0
     for(let reg of filas){
       // console.log(X[index-1].saldo_final)
         let r : any = {}
         if(index === 0) r = { saldo_inicial : inversion, cargos :  (inversion * ( tasa_incremento / 100 )), saldo_final : (inversion + ( (inversion * ( tasa_incremento / 100 )) ) + 0 )    }
          else{ 
            r = { saldo_inicial : X[index-1].saldo_final, cargos :  ((X[index-1].saldo_final * ( tasa_incremento / 100 ))), saldo_final : (X[index-1].saldo_final + ( (X[index-1].saldo_final * ( tasa_incremento / 100 )) ) + 0 )    }
            // console.log(X[index-1].saldo_final)
          }
         // return r

       // console.log([...X])
       // console.log(index)
       X.push(r)
       index++
     }
     setTablaFinal(X)
                                                           // .map((numero_mes:any,index:number)=>{ 

                                                           // })

     // setTablaFinal(filas)

     setGenerado(true)


     setGenerando(false)

 }


  return (
    <div className="container">

      <div className="row mt-4">
        <div className="col-3 col-sm-3">
          
          <div className="mb-3">
            <label className="form-label">Inversión</label>
            <input type="text" disabled={generado} className="form-control" value={inversion} onChange={(e:any)=>{setInversion(parseFloat(e.target.value))}} />
          </div>

          <div className="mb-3">
            <label className="form-label">Tasa de Incremento (%)</label>
            <input type="text" disabled={generado} className="form-control" value={tasa_incremento} onChange={(e:any)=>{setTasaIncremento(e.target.value)}} />
          </div>


          <div className="mb-3">
            <label className="form-label">Plazo Contratado en meses</label>
            <select disabled={generado} className="form-select" value={meses_inversion} onChange={(e:any)=>{setMesesInversion(e.target.value)}}>
              <option >Selecciona la cantidad de tiempo</option>
              <option value={6}>6 MESES</option>
              <option value={7}>7 MESES</option>
              <option value={8}>8 MESES</option>
              <option value={9}>9 MESES</option>
              <option value={10}>10 MESES</option>
              <option value={11}>11 MESES</option>
              <option value={12}>12 MESES</option>
              <option value={13}>13 MESES</option>
              <option value={14}>14 MESES</option>
              <option value={15}>15 MESES</option>
              <option value={16}>16 MESES</option>
              <option value={17}>17 MESES</option>
              <option value={18}>18 MESES</option>
              <option value={19}>19 MESES</option>
              <option value={20}>20 MESES</option>
              <option value={21}>21 MESES</option>
              <option value={22}>22 MESES</option>
              <option value={23}>23 MESES</option>
              <option value={24}>24 MESES</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Tipo de Retiro</label>
            <div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={tipo_retiro==='mensual'} onChange={(e:any)=>{setTipoRetiro("mensual")}} />
                <label className="form-check-label" htmlFor="inlineRadio1">Mensual</label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={tipo_retiro==='finalizando'} onChange={(e:any)=>{setTipoRetiro("finalizando")}} />
                <label className="form-check-label" htmlFor="inlineRadio2">Al Finalizar el Contrato</label>
              </div>
            </div>
          </div>



  <button type="submit" disabled={false} onClick={generarReporte} className="btn btn-primary">Generar</button>
  {' '}
  <button type="submit" onClick={(e:any)=>{setGenerado(false)}} className="btn btn-danger">Recálculo</button>



        </div>
        <div className="col-sm">
          
          {
            !generando && (

                <React.Fragment>

                  {
                    generado && (
                        <React.Fragment>
                          

                                    <h2>Reporte de Inversión</h2>

                                    <p className="nm+"><a target="_blank" href={`${SERVER_}reporte_inversion/${inversion}/${tasa_incremento}/${meses_inversion}`}><small>Imprimir Reporte</small></a></p>

                          {
                            tipo_retiro === 'mensual' && (
                                <React.Fragment>



                                    <div className="row mb-4">
                                      <div className="col-sm">
                                        
                                        <p>Rendimiento Ganado</p>
                                        <h4>$ {
                                          formatearNumeroConComas(
                                            (Array.from({ length: meses_inversion }, (_, index) => index)).map((p:any)=>{return inversion*(tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0)
                                            )
                                        }
                                        {' '}
                                        <small>({
                                          formatearNumeroConComas(((Array.from({ length: meses_inversion }, (_, index) => index)).map((p:any)=>{return inversion*(tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) / inversion ) * 100)
                                        } %)</small>

                                        </h4>

                                      </div>
                                      <div className="col-sm">
                                        <p>Retención de ISR</p>
                                        <h4>
                                          $ {
                                            formatearNumeroConComas((Array.from({ length: meses_inversion }, (_, index) => index)).map((p:any)=>{return inversion*(tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) * .20)
                                          }
                                        </h4>
                                        
                                      </div>
                                      <div className="col-sm">
                                        <p>Neto a Recibir</p>
                                        <h4>$ {
                                          formatearNumeroConComas(
                                            (Array.from({ length: meses_inversion }, (_, index) => index)).map((p:any)=>{return inversion*(tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0)
                                            -
                                            ((Array.from({ length: meses_inversion }, (_, index) => index)).map((p:any)=>{return inversion*(tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) * .20)
                                          )
                                        }</h4>
                                          
                                      </div>
                                    </div>




                                    <table className="table table-sm">
                                      <thead style={{fontSize:10}}>
                                        <tr>
                                          <th scope="col">No. De Meses</th>
                                          <th style={{width:'14%'}} scope="col">Saldo Inicial</th>
                                          <th style={{width:'14%'}} scope="col">Cargos</th>
                                          <th style={{width:'14%'}} scope="col">Abonos</th>
                                          <th style={{width:'14%'}} scope="col">Saldo Final</th>
                                          <th style={{width:'14%'}} scope="col">Retención de ISR</th>
                                          <th style={{width:'14%'}} scope="col">Neto a recibir mensual</th>
                                        </tr>
                                      </thead>
                                      <tbody style={{fontSize:12}}>

                                        <tr>
                                          <td>0</td>
                                          <td>$ {formatearNumeroConComas(inversion)}</td>
                                          <td></td>
                                          <td></td>
                                          <td>$ {formatearNumeroConComas(f17)}</td>
                                          <td></td>
                                          <td></td>
                                        </tr>

                                      {
                                        Array.from({ length: meses_inversion }, (_, index) => index).map((numero_mes:any,index:number)=>

                                          <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                            
                                        <tr>
                                          <td>{index+1}</td>
                                          <td>$ {formatearNumeroConComas(inversion)}</td> {/*saldo_inicial*/}
                                          <td>$ {formatearNumeroConComas(inversion*(tasa_incremento/100))}</td>{/*Cargos*/}
                                          <td>$ {formatearNumeroConComas(inversion*(tasa_incremento/100))}</td>{/*Abonos*/}
                                          <td>
                                            $ { formatearNumeroConComas((inversion) + (inversion*(tasa_incremento/100)) - (inversion*(tasa_incremento/100))) }
                                          </td>{/*Saldo Final*/}
                                          <td>$ {formatearNumeroConComas(((inversion*(tasa_incremento/100)) * .2))}</td>{/*Retención de ISR*/}
                                          <td>$ {formatearNumeroConComas((inversion*(tasa_incremento/100)) - ((inversion*(tasa_incremento/100)) * .2))}</td>{/*Neto a recibir mensual*/}
                                        </tr>

                                          </React.Fragment>

                                          )
                                      }
                                      </tbody>
                                    </table>




                                </React.Fragment>
                              )
                          }



                          {
                            tipo_retiro === 'finalizando' && (
                                <React.Fragment>



                                    <div className="row mb-4">
                                      <div className="col-sm">
                                        
                                        <p>Rendimiento Ganado</p>
                                        <h4>$ {
                                          formatearNumeroConComas(tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0))
                                        }
                                        {' '}
                                        <small>({
                                          formatearNumeroConComas( (tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) / inversion * 100)
                                        } %)</small>

                                        </h4>

                                      </div>
                                      <div className="col-sm">
                                        <p>Retención de ISR</p>
                                        <h4>
                                          $ {
                                            formatearNumeroConComas( (tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) * .20 )
                                          }
                                        </h4>
                                        
                                      </div>
                                      <div className="col-sm">
                                        <p>Neto a Recibir</p>
                                        <h4>$ {
                                          formatearNumeroConComas(
                                            tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)
                                            -
                                            ((tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) * .20)
                                            )
                                        }</h4>
                                          
                                      </div>
                                    </div>





{

  // JSON.stringify(tabla_final)
}





                                    <table className="table table-sm">
                                      <thead style={{fontSize:10}}>
                                        <tr>
                                          <th scope="col">No. De Meses</th>
                                          <th style={{width:'14%'}} scope="col">Saldo Inicial</th>
                                          <th style={{width:'14%'}} scope="col">Cargos</th>
                                          <th style={{width:'14%'}} scope="col">Abonos</th>
                                          <th style={{width:'14%'}} scope="col">Saldo Final</th>
                                          <th style={{width:'14%'}} scope="col">Retención de ISR</th>
                                          <th style={{width:'14%'}} scope="col">Neto a recibir mensual</th>
                                        </tr>
                                      </thead>
                                      <tbody style={{fontSize:12}}>

                                        <tr>
                                          <td>0</td>
                                          <td>$ {formatearNumeroConComas(inversion)}</td>
                                          <td></td>
                                          <td></td>
                                          <td>$ {formatearNumeroConComas(f17)}</td>
                                          <td></td>
                                          <td></td>
                                        </tr>

                                      {
                                        tabla_final.map((registro:any,index:number)=>

                                          <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                            
                                        <tr>
                                          <td>{index+1}</td>
                                          <td>$ {formatearNumeroConComas(registro.saldo_inicial)}</td> {/*saldo_inicial*/}
                                          <td>$ {formatearNumeroConComas(registro.cargos)}</td>{/*Cargos*/}
                                          <td>-</td>{/*Abonos*/}
                                          <td>
                                            $ { formatearNumeroConComas(registro.saldo_final) }
                                          </td>{/*Saldo Final*/}
                                          <td>-</td>
                                          <td>-</td>
                                        </tr>

                                          </React.Fragment>

                                          )
                                      }
                                      </tbody>
                                    </table>









                                </React.Fragment>
                              )
                          }




                        </React.Fragment>
                      )
                  }

                  {
                    !generado && (
                        <React.Fragment>
                            {
                              // EN ESPERA DE QUE LO CREÉS
                            }
                        </React.Fragment>
                      )
                  }

                </React.Fragment>


              )
          }






          {
            generando && (

                <React.Fragment>

                  Generando...
                  
                </React.Fragment>


              )
          }

        </div>
      </div>


    </div>
  );
}

export default Calculadora
